const isValidEmail = (email?: string) => {
  if (!email) return false
  const regExp = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
  return regExp.test(email)
}

export default isValidEmail
